<template>
  <b-card
    tag="article"
    no-body
    class="item-card"
    :class="{
      'card-wide': item.wideView === 1,
      'card-large': column == 2,
      'card-small': column == 3,
    }"
    @click="goOrder(item)"
  >
    <div class="image-spacer">
      <div v-if="isPriceDisplay" class="price">
        <div v-if="isUs" class="price is-us">
          {{ $t('common.dollar', { price: (item.price / 100).toFixed(2) }) }}
        </div>
        <div v-if="!isUs">{{ item.price | setComma }}</div>
        <div v-if="isJp" class="unit">{{ $t('common.yen') }}</div>
        <div v-if="isTw" class="unit">{{ $t('common.twGen') }}</div>
        <div v-if="isCn" class="unit">{{ $t('common.cnGen') }}</div>
      </div>
      <img
        v-if="isJp && isBikkuraponIconDisplay && isBikkurapon(item.unit)"
        class="bikkurapon-icon"
        src="@/assets/images/bikkurapon_icon.png"
        alt=""
      />
      <img
        v-if="isTw && isBikkuraponIconDisplay && isBikkurapon(item.unit)"
        class="bikkurapon-icon"
        src="@/assets/images/bikkurapon_icon_tw.png"
        alt=""
      />
      <img
        v-if="isUs && isBikkuraponIconDisplay && isBikkurapon(item.unit)"
        class="bikkurapon-icon"
        src="@/assets/images/bikkurapon_icon_us.png"
        alt=""
      />
      <img
        v-if="isCn && isBikkuraponIconDisplay && isBikkurapon(item.unit)"
        class="bikkurapon-icon"
        src="@/assets/images/bikkurapon_icon_cn.png"
        alt=""
      />
      <b-card-img :src="item.itemImage" class="item-card-image" @error="replaceByDefault" />
    </div>
    <b-card-text style="font-size: 14px; text-align: left; font-weight: bold; padding: 5px">
      {{ item.name }}
    </b-card-text>
  </b-card>
</template>
<script>
import noImage from '@/assets/images/noimage.png'
export default {
  name: 'MenuList',
  filters: {
    setComma: function (value) {
      return value.toLocaleString()
    },
  },
  props: {
    item: Object,
    column: null,
    isPriceDisplay: Boolean,
    isBikkuraponIconDisplay: Boolean,
  },
  data() {
    return {
      displayData: [],
      noImage: noImage,
    }
  },
  computed: {
    isBikkurapon() {
      return (unit) => {
        return unit !== 0
      }
    },
    defaultLanguage() {
      return process.env.VUE_APP_LANG
    },
    isJp() {
      return this.defaultLanguage === 'ja'
    },
    isTw() {
      return this.defaultLanguage === 'zh-tw'
    },
    isUs() {
      return this.defaultLanguage === 'us'
    },
    isCn() {
      return this.defaultLanguage === 'zh-cn'
    },
  },
  methods: {
    goOrder(item) {
      const name = this.$route.name === 'shopMenu' ? 'order' : `${this.$route.name}Order`
      this.$router.push({ name, params: { id: item.itemCode } })
    },
    replaceByDefault(e) {
      e.target.src = noImage
    },
  },
}
</script>
<style lang="scss" scoped>
.item-card {
  height: auto;

  .image-spacer {
    position: relative;
    width: 100%;
    padding-top: 60%;
    overflow: hidden;
  }

  .price {
    display: flex;
    align-items: baseline;
    position: absolute;
    bottom: 0;
    left: 6px;
    z-index: 1;
    color: #fff;
    font-weight: bold;
    text-shadow: 0px 0px 2px black, 0px 0px 2px black, 0px 0px 3px black;
    font-family: 'Zen Antique Soft', serif;

    .unit {
      font-family: 'Zen Antique Soft', serif;
    }
    &.is-us {
      bottom: 1px;
      left: 0;
    }
  }

  .bikkurapon-icon {
    position: absolute;
    top: 4px;
    left: 3px;
    z-index: 1;
    width: 27%;
  }

  .item-card-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
  }
}
.card-large {
  width: calc((100% / 2) - 10px);
  margin: 0 5px;
  margin-bottom: 10px;
  @media (min-width: 560px) {
    width: calc((100% / 4) - 10px);
  }
  .price {
    font-size: clamp(20px, 5.8vw, 32px);

    @media (min-width: 560px) {
      font-size: clamp(20px, 3.9vw, 32px);
    }

    .unit {
      margin-left: 1px;
      font-size: clamp(12px, 3.7vw, 18px);

      @media (min-width: 560px) {
        font-size: clamp(12px, 2.4vw, 18px);
      }
    }
  }
}
.card-small {
  width: calc((100% / 3) - 10px);
  margin: 0 5px;
  margin-bottom: 10px;
  @media (min-width: 560px) {
    width: calc((100% / 6) - 10px);
  }

  .price {
    font-size: clamp(16px, 4.8vw, 26px);

    @media (min-width: 560px) {
      font-size: clamp(16px, 2.4vw, 26px);
    }
    .unit {
      margin-left: 1px;
      font-size: clamp(10px, 3.2vw, 16px);
      text-align: center;

      @media (min-width: 560px) {
        font-size: clamp(10px, 1.7vw, 16px);
      }
    }
  }
}
.card-wide {
  clear: both;
  width: calc(100% - 10px) !important;
  @media (min-width: 560px) {
    width: calc((100% / 2) - 10px) !important;
  }
  .price {
    font-size: clamp(38px, 10.6vw, 50px);

    @media (min-width: 560px) {
      font-size: clamp(38px, 6.7vw, 50px);
    }

    .unit {
      margin-left: 2px;
      font-size: clamp(20px, 3.5vw, 26px);

      @media (min-width: 560px) {
        font-size: clamp(22px, 3.9vw, 26px);
      }
    }
  }
}
</style>
